var map = {
	"./images/10_min_ceo_2.jpeg": 8434,
	"./images/10_min_delivery_ceo.webp": 8620,
	"./images/Brand.png": 9017,
	"./images/background.png": 9435,
	"./images/background.svg": 5892,
	"./images/brand-white-mobile.png": 5933,
	"./images/brand-white.png": 794,
	"./images/dropdown-arrow-green.png": 5558,
	"./images/freshness-mobile-png.png": 3892,
	"./images/ic-chevron-down.png": 4029,
	"./images/jeff_bezzos_laugh.gif": 4471,
	"./images/products/bakery/bread/bread1.webp": 7141,
	"./images/products/bakery/brown-eggs/brownEgg-1.png": 1480,
	"./images/products/bakery/cheese/cheese-1.webp": 3458,
	"./images/products/bakery/cheese/cheese-2.webp": 2663,
	"./images/products/bakery/cheese/cheese-3.webp": 469,
	"./images/products/bakery/cheese/cheese-4.webp": 3696,
	"./images/products/bakery/curd/curd-1.webp": 8576,
	"./images/products/bakery/egg/egg-1.webp": 3109,
	"./images/products/bakery/egg/egg-2.webp": 5070,
	"./images/products/bakery/egg/egg-3.webp": 9723,
	"./images/products/bakery/milk/milk-1.webp": 1031,
	"./images/products/bakery/quailEgg/QuailEgg-1.jpeg": 1511,
	"./images/products/bakery/soymilk/soy-milk-1.webp": 4402,
	"./images/products/drinks/beer/beer-1.webp": 7376,
	"./images/products/drinks/glucond/glucond-1.webp": 8392,
	"./images/products/drinks/glucond/glucond-2.webp": 915,
	"./images/products/drinks/glucond/glucond-3.webp": 5409,
	"./images/products/drinks/monster/monster-1.webp": 9554,
	"./images/products/drinks/monster/monster-2.webp": 5981,
	"./images/products/drinks/protien/protienX1.webp": 9234,
	"./images/products/drinks/redbull/redBull.webp": 9627,
	"./images/products/drinks/sting/sting-1.webp": 2762,
	"./images/products/drinks/sting/sting-2.webp": 3212,
	"./images/products/drinks/yakult/yakut1.webp": 6469,
	"./images/products/fruits&vegetables/blueberries/blueberries.webp": 6977,
	"./images/products/fruits&vegetables/carrots/carrot-1.webp": 5924,
	"./images/products/fruits&vegetables/mango/mango-1.webp": 6520,
	"./images/products/fruits&vegetables/mango/mango-2.webp": 2529,
	"./images/products/fruits&vegetables/pomegranate/pomogranate-1.webp": 9788,
	"./images/products/fruits&vegetables/pomegranate/pomogranate-2.webp": 1907,
	"./images/products/fruits&vegetables/sweet-potato/sweet_potato.webp": 7593,
	"./images/products/fruits&vegetables/watermelon/watermelon-1.webp": 7962,
	"./images/products/fruits&vegetables/watermelon/watermelon-2.webp": 4104,
	"./images/products/meat&fish/chicken-breast/chicken_breast-1.webp": 5660,
	"./images/products/meat&fish/chicken-curry-cut/chicken_curry_cut-1.webp": 6927,
	"./images/products/meat&fish/chicken-drumstick/chicken_drumstick-1.webp": 8028,
	"./images/products/meat&fish/mutton-boneless/mutton-boneless-1.jpeg": 913,
	"./images/products/meat&fish/mutton-lean-curry-cut/lean_goat_curry-cut-1.png": 11,
	"./images/products/meat&fish/mutton_curry_cut.png": 6129,
	"./images/products/meat&fish/prawns/prawns-1.webp": 4,
	"./images/products/meat&fish/salmon/salmon-1.webp": 7018,
	"./images/products/meat&fish/tuna/tuna.webp": 6877,
	"./images/promises/express-delivery-icon.webp": 6908,
	"./images/promises/footer-best-price.webp": 2722,
	"./images/promises/footer-easy-returns.webp": 4115,
	"./images/promises/footer-genuine-products.webp": 315,
	"./images/recipes/chicken-boil.jpeg": 8528,
	"./images/recipes/chicken-curry.jpeg": 5923,
	"./images/recipes/chicken-tikka-masala-spicy.webp": 1,
	"./images/recipes/jeff_bezzos_laugh.gif": 9749,
	"./images/recipes/mutton-curry.jpeg": 8095,
	"./images/recipes/mutton-recipe.webp": 1405,
	"./images/search-icon.png": 674,
	"./scss/App.scss": 3582,
	"./scss/_breakpoints.scss": 3555,
	"./scss/_mixins.scss": 9707,
	"./scss/_variables.scss": 724,
	"./scss/common.scss": 7746,
	"./scss/common/button/button.scss": 6364,
	"./scss/common/button/ctaButton.scss": 339,
	"./scss/common/card/productCardOne.scss": 8674,
	"./scss/common/card/productCardTwo.scss": 7763,
	"./scss/common/card/recipeCard.scss": 6511,
	"./scss/common/carousels/singleSlideCarousel.scss": 6440,
	"./scss/common/carousels/slideCarousel.scss": 657,
	"./scss/common/coupon/coupon.scss": 1656,
	"./scss/common/dropdown/dropdownListOne.scss": 8448,
	"./scss/common/footer/footer.scss": 6045,
	"./scss/common/input/inputElementOne.scss": 9441,
	"./scss/common/input/inputElementTwo 2.scss": 2991,
	"./scss/common/input/inputElementTwo.scss": 8950,
	"./scss/common/list/listItemCard.scss": 4466,
	"./scss/common/list/listOne.scss": 1676,
	"./scss/common/list/listRating.scss": 3332,
	"./scss/common/navbar.scss": 7200,
	"./scss/common/rangeslider/RangeSlider.scss": 347,
	"./scss/common/rating/rating.scss": 8322,
	"./scss/common/starlist/starlist.scss": 4700,
	"./scss/common/tags/tags.scss": 9485,
	"./scss/common/toast/toast.scss": 7004,
	"./scss/index.scss": 8261,
	"./scss/screens/categoryListing.scss": 8308,
	"./scss/screens/checkout/billUserInfo 2.scss": 1475,
	"./scss/screens/checkout/billUserInfo.scss": 6651,
	"./scss/screens/checkout/cartProduct.scss": 4448,
	"./scss/screens/checkout/checkout.scss": 8816,
	"./scss/screens/homepage.scss": 7674,
	"./scss/screens/login/login.scss": 1362,
	"./scss/screens/product/product.scss": 9396,
	"./scss/screens/product/productPromises.scss": 9999,
	"./scss/screens/wishlist.scss": 5630
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;